import { render, staticRenderFns } from "./UserSolidIcon.vue?vue&type=template&id=9b463412"
import script from "./UserSolidIcon.vue?vue&type=script&lang=js"
export * from "./UserSolidIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports